import {
  AlertTriangle,
  CheckCircle2,
  CloudOff,
  Info,
  Loader2,
  Lock,
  Undo2,
  XCircle,
} from "lucide-react";

export const TOAST_VARIANTS = {
  success: {
    icon: CheckCircle2,
    token: "success",
    role: "status" as const,
    ariaLive: "polite" as const,
    spin: false as const,
  },
  error: {
    icon: XCircle,
    token: "error",
    role: "alert" as const,
    ariaLive: "assertive" as const,
    spin: false as const,
  },
  warning: {
    icon: AlertTriangle,
    token: "warning",
    role: "status" as const,
    ariaLive: "polite" as const,
    spin: false as const,
  },
  info: {
    icon: Info,
    token: "info",
    role: "status" as const,
    ariaLive: "polite" as const,
    spin: false as const,
  },
  loading: {
    icon: Loader2,
    token: "pending",
    role: "status" as const,
    ariaLive: "polite" as const,
    spin: true as const,
  },
  undo: {
    icon: Undo2,
    token: "undo",
    role: "status" as const,
    ariaLive: "polite" as const,
    spin: false as const,
  },
  blocked: {
    icon: Lock,
    token: "blocked",
    role: "alert" as const,
    ariaLive: "assertive" as const,
    spin: false as const,
  },
  queued: {
    icon: CloudOff,
    token: "queued",
    role: "status" as const,
    ariaLive: "polite" as const,
    spin: false as const,
  },
} as const;

export type ToastVariantKey = keyof typeof TOAST_VARIANTS;
